import { Box } from '@mui/material'
import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'

import { logger } from '../../services/logger'

import AppRouterContainer from '../../components/AppRouter/AppRouter.container'
import AuthProvider from '../../components/AuthContext/AuthProvider'
import HeaderComponent from '../../components/Header/Header.component'

const MainContainer: React.FC = (): JSX.Element => {
  logger.debug('MainContainer')

  return (
    <Router>
      <AuthProvider>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            backgroundColor: '#1E1E1E'
          }}
        >
          <HeaderComponent />
          <main style={{ flexGrow: 1 }}>
            <AppRouterContainer />
          </main>
        </Box>
      </AuthProvider>
    </Router>
  )
}

export default MainContainer
